<template>
  <div class="pricing-form">
    <Spin v-if="loading"></Spin>
    <Form v-else ref="pricingForm" :model="formData" :rules="ruleValidate" label-position="top">
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('product.info.unit_price')" prop="data.unit_price">
            <Money v-model="formData.data.unit_price" :currency="formData.data.currency" disable-currency></Money>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('product.info.unit_cost')" prop="data.unit_cost">
            <Money v-model="formData.data.unit_cost" :currency="formData.data.currency" disable-currency></Money>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('product.info.currency')" prop="data.currency">
            <CurrencySelect :value.sync="formData.data.currency"></CurrencySelect>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('product.info.margin')">
            <Money v-model="marginValue" :currency="formData.data.currency" disabled></Money>
          </FormItem>
        </Col>
      </Row>
      <div class="text-align-right actions">
        <Button type="primary" @click="handleSubmit('productForm')" size="large">{{ $t('save') }}</Button>
      </div>
    </Form>
  </div>
</template>

<script>
import AccountSearchAndPickWidget from '@/view/account/components/widgets/account-search-and-pick-widget.vue'
import Editor from '@/components/editor'
import Money from '@/components/inputs/money'
import CurrencySelect from '@/components/currency'
import { generateProductNumber } from '@/api/product'
export default {
  name: 'PricingForm',
  components: {
    AccountSearchAndPickWidget,
    Editor,
    Money,
    CurrencySelect
  },
  props: {
    pricing: {
      type: Object,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      formData: {
        data: {
          unit_cost: 0,
          unit_price: 0,
          currency: 'CNY'
        }
      }
    }
  },
  computed: {
    marginValue () {
      return this.formData.data.unit_price - this.formData.data.unit_cost
    },
    isNew () {
      return !this.formData.id
    },
    isServiceType () {
      return this.formData.product_type === 'service'
    },
    preventProductNumberChange () {
      return !!(this.formData.id && this.formData.product_number)
    }
  },
  methods: {
    generateProductNumber,
    handleSubmit (ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.$emit('save-product', this.formData)
        }
      })
    },
    handleProductCategoryChange (value) {
      this.formData.product_data_type = `product__${value}_data_type`
    },
    handleGenerateProductNumber () {
      const prefix = this.formData.product_type === 'service' ? 'FY-' : 'PD-'
      this.generateProductNumber(prefix)
        .then(resp => {
          this.formData = Object.assign({}, this.formData, { product_number: resp.data })
        })
    }
  },
  watch: {
    'formData.product_type': function (val) {
      if (val && val === 'service') {
        this.formData.product_data_type = `product__service_data_type`
      }
    },
    loading: function () {
      this.formData = Object.assign({}, this.formData, this.product)
    }
  }
}
</script>
